import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'hasPatternDescription',
})
export class HasPatternDescriptionPipe implements PipeTransform {
	
	transform<T>(value: T): value is T & {patternDescription: string;} {
		return 'patternDescription' in value && typeof value['patternDescription'] === 'string';  
	}
	
}
